import React from 'react';

export enum Orientation {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}

const PORTRAIT_QUERY = `(orientation: ${Orientation.PORTRAIT})`;

const getOrientation = (mediaQueryList: MediaQueryList): Orientation => (
  mediaQueryList.matches ? Orientation.PORTRAIT : Orientation.LANDSCAPE
);

const useOrientation = (): Orientation => {
  const [orientation, setOrientation] = React.useState<Orientation>(
    () => getOrientation(window.matchMedia(PORTRAIT_QUERY)),
  );

  React.useEffect(() => {
    const mediaQueryList = window.matchMedia(PORTRAIT_QUERY);
    const handleChange = () => {
      setOrientation(getOrientation(mediaQueryList));
    };
    mediaQueryList.addEventListener('change', handleChange);
    return () => {
      mediaQueryList.removeEventListener('change', handleChange);
    };
  }, []);

  return orientation;
};

export default useOrientation;
